import React from 'react';
import { Link, browserHistory } from 'react-router';
import { Button, Dialog } from "@blueprintjs/core";
import { ShowIf } from 'components/utils';
import { LetterProcessingWorkFlow, GiaiQuyetDonThu } from 'api';
import { validatable } from 'components/utils';
import { Toastr } from 'modules/toastr';
import { LanhDaoGiaoViecTTXMPU, ThuHoiGQ, LanhDaoGiaoViecKTDXPU, LanhDaoGiaoViecPU, TruongPhongGiaoViecPU, ThuHoiPU } from './thu-hoi-form';
import { ConvertParams } from 'components/modules/handle-letters/xu-ly-don/ParamsGiaiQuyetDon.jsx';
import { connect } from 'react-redux';

class ThuHoiDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

      isThuHoi: false,
      donId: this.props.donId,
      content: '',
      params: {},
      noticeMsg: 'Thu hồi đơn thành công',
      processTypeValue: '',
      // Tai GUI
      alias: '',
      listNextStates: '',
      nextState: '',

      isOpen: false
    }
  }

  componentDidMount() {

  }

  getState(listNextStates, type) {

    let stateId = null;

    listNextStates.map((item, i) => {

      if (item.type == type) {

        stateId = item.stateId;
        return stateId;
      }
    })
    return stateId;
  }

  getCurrentForm(donId) {
    LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(res => {
      if (res.data) {
        let info = res.data;
        let content = '';
        if (info.currentForm.alias == 'ThuHoiDonAction' || info.currentForm.alias == 'ThuHoiDonGQAction' || info.currentForm.alias == 'ThuHoiDonTDTHaction') {
          content = 'Sau khi xác nhận thu hồi, đơn sẽ được chuyển đến trang "Công việc đang xử lý"';
        } else {
          content = 'Đơn đã thu hồi sẽ được giao cho';
        }

        this.setState({
          alias: info.currentForm.alias,
          listNextStates: info.listNextStates,
          processTypeValue: info.currentForm.processTypeInfo.giaTri,
          content: content
        })
      }
    }).catch(error => {

      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    })
  }

  postXuLyDon() {
    if (this.validateSubmitForm()) {

      let params = this.state.params;

      params.don = {
        id: Number(this.state.donId)
      };
        // this.setState({
        //   btnLoading: true,
        // });

      LetterProcessingWorkFlow.actions.postXuLyDon.request('', params).then(res => {

        Toastr(this.state.noticeMsg, 'success');

        if (this.state.alias == 'ThuHoiDonAction' && !this.state.isThuHoi) {

          this.setState({
            isThuHoi: true
          })

          this.getCurrentForm(this.state.donId);
        } else {
          this.toggleDialog();
        }
        this.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        // this.setState({
        //   btnLoading: false,
        // });
      });
    }
  }

  postGiaiQuyetDon() {

    if (this.validateSubmitForm()) {

      // this.setState({
      //   btnLoading: true,
      // });

      let paramsPost = this.state.params.paramsPost;

      paramsPost.thongTinGiaiQuyetDon = {
        id: this.props.thongTinGiaiQuyetDonId
      }

      GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', paramsPost).then(res => {
        Toastr(this.state.noticeMsg, 'success');

        if ((this.state.alias == 'ThuHoiDonGQAction' || this.state.alias == 'ThuHoiDonTDTHaction') && !this.state.isThuHoi) {

          this.setState({
            isThuHoi: true
          })

          this.getCurrentForm(this.state.donId);
        } else {
          this.toggleDialog();
        }
        this.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
      }).catch(error => {

        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }

  patchGiaiQuyetDon() {

    if (this.validateSubmitForm()) {

      // this.setState({
      //   btnLoading: true,
      //   btnSaveLoading: true
      // });
      let paramsPatch = ConvertParams(this.state.params.paramsPatch, this.state.donId);

      GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.props.thongTinGiaiQuyetDonId }, paramsPatch).then(res => {
        this.postGiaiQuyetDon();
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }

  onPostClick() {
    if (this.state.processTypeValue == 'XU_LY_DON') {
      this.postXuLyDon();
    } else {
      this.patchGiaiQuyetDon();
    }
  }

  handleDataForm(state) {
    let noticeMsg = state.notice;
    let nextState = '';
    if (state.nextStateType) {
      nextState = state.nextStateType
    }
    delete state.messege;

    this.setState({
      params: state,
      noticeMsg: noticeMsg,
      nextState: nextState
    })
  }

  validateSubmitForm() {
    let pass = true;
    if (typeof this.props.validators['formTaoDon'] != 'undefined') {
      this.props.validators['formTaoDon'].map(validator => {
        if (pass) {
          pass = validator.validate();
        }
        else
          validator.validate();
      });
    }
    return pass;
  }

  toggleDialog() {

    if (!this.state.isOpen) {
      this.getCurrentForm(this.state.donId);
    }
    this.setState({ isOpen: !this.state.isOpen });

    // get lai danh sach du lieu
    if (this.state.isThuHoi) {
      this.props.getListData();
    }
  }

  gotoPage() {
    browserHistory.push('/thu-hoi-xu-ly-don/xu-ly/dang/' + this.state.donId);
  }

  render() {
    return (
      <div className="wrap-link-todo">
        <Link className="itt-thu-hoi" onClick={this.toggleDialog.bind(this)}>
          Thu hồi
        </Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.toggleDialog.bind(this)}
          title={this.props.title}
          className="reception-dialog delete-dialog">

          {/* THU_HOI */}
          <ShowIf condition={this.state.alias == 'ThuHoiDonAction'}>
            <ThuHoiPU
              donId={this.state.donId}
              content={this.state.content}
              onChange={this.handleDataForm.bind(this)}
              listNextStates={this.state.listNextStates}
              getState={this.getState.bind(this)}
              bindValidator={this} />
          </ShowIf>
          <ShowIf condition={this.state.alias == 'ThuHoiDonGQAction' || this.state.alias == 'ThuHoiDonTDTHaction'}>
            <ThuHoiGQ
              donId={this.state.donId}
              content={this.state.content}
              onChange={this.handleDataForm.bind(this)}
              listNextStates={this.state.listNextStates}
              getState={this.getState.bind(this)}
              bindValidator={this}
              thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId} />
          </ShowIf>

          {/* LANH_DAO_GIAO_VIEC */}
          <ShowIf condition={this.state.alias == 'ManagerAction'}>
            <LanhDaoGiaoViecPU
              content={this.state.content}
              donId={this.state.donId}
              onChange={this.handleDataForm.bind(this)}
              listNextStates={this.state.listNextStates}
              getState={this.getState.bind(this)}
              bindValidator={this} />
          </ShowIf>

          {/* TRUONG_PHONG_GIAO_VIEC */}
          <ShowIf condition={this.state.alias == 'LeaderAction'}>
            <TruongPhongGiaoViecPU
              content={this.state.content}
              donId={this.state.donId}
              onChange={this.handleDataForm.bind(this)}
              listNextStates={this.state.listNextStates}
              getState={this.getState.bind(this)}
              bindValidator={this} />
          </ShowIf>

          {/* LANH_DAO_GIAO_VIEC_KTDX */}
          <ShowIf condition={this.state.alias == 'lanhDaoKiemTraDeXuat'}>
            <LanhDaoGiaoViecKTDXPU
              donId={this.state.donId}
              content={this.state.content}
              onChange={this.handleDataForm.bind(this)}
              listNextStates={this.state.listNextStates}
              getState={this.getState.bind(this)}
              bindValidator={this}
              thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
            />
          </ShowIf>

          <ShowIf condition={this.state.alias == 'LanhDaoTTXMAction' || this.state.alias == 'LanhDaoTDTHAction'}>
            <LanhDaoGiaoViecTTXMPU
              donId={this.state.donId}
              content={this.state.content}
              onChange={this.handleDataForm.bind(this)}
              listNextStates={this.state.listNextStates}
              getState={this.getState.bind(this)}
              bindValidator={this}
              thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
            />
          </ShowIf>

          <div className="pt-dialog-footer">
            <div className="pt-dialog-footer-actions reception-delete-confirm">
              <Button
                onClick={this.toggleDialog.bind(this)}
                text="Không"
                className="btn-default"
              />
              <ShowIf condition={this.state.alias != 'LeaderAction' || this.state.nextState != 'KET_THUC'}>
                <Button
                  onClick={this.onPostClick.bind(this)}
                  text="Đồng ý"
                  className="btn-green"
                />
              </ShowIf>
              <ShowIf condition={this.state.alias == 'LeaderAction' && this.state.nextState == 'KET_THUC'}>
                <Button
                  onClick={this.gotoPage.bind(this)}
                  text="Xác nhận"
                  className="btn-green"
                />
              </ShowIf>
            </div>
          </div>
        </Dialog>
      </div>

    );
  }
}

ThuHoiDialog.defaultProps = {
  validators: []
}

export default connect()(validatable(ThuHoiDialog));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/ThuHoiDialog.jsx